export const PLAT_TYPE_MENU_TOOL = {
  DOUYIN: {
    value: 1,
    desc: "抖音",
    icon: "icon-douyin",
  },
  XIAOHS: {
    value: 2,
    desc: "小红书",
    icon: "icon-xiaohongshu",
    colorClass: "m_color_e1",
  },
  WEIXIN: {
    value: 4,
    desc: "微信",
    icon: "icon-wechat1",
    colorClass: "m_color_wechat",
  },
  WANGYE: {
    value: 3,
    desc: "网页",
    icon: "icon-zhinengwangyehuise",
    colorClass: "m_color_webh5",
  },
  KUAISHOU: {
    value: 5,
    desc: "快手",
    icon: "icon-kuaishou11",
    colorClass: "m_color_kuaishou",
  },
  LAIKEim: {
    value: 10,
    desc: "来客IM",
    icon: "icon-douyinlaike",
    colorClass: "m_color_laikeim",
  },
  SHIPINHAO: {
    value: 12,
    desc: "视频号",
    icon: "icon-shipinhao",
    colorClass: "m_color_shipinhao",
  },
};

//支持已读的平台ID
export const SUPPOERT_READ_RECEIPT_PLAT_TYPES = [1];

export default {
  PLAT_TYPE_MENU_TOOL,
};
